import React, {useEffect, useState, useRef} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom'

// styles
import styles from './memberMail.module.css';

// actions
import {fetchMessages} from "../../store/actions/postsActions";

// components
import ClientHeader from "../clientHeader/clientHeader";
import {fetchUserCoaches} from "../../store/actions/userActions";
import {PrimaryLink} from "../links/links";
import MailList from "./mailList/mailList";
import {MAIL_VIEWS} from "./views";

const MemberMail = props => {
    // props
    const {user} = props;
    // local
    const [coaches, setCoaches] = useState([]);
    const [page, setPage] = useState(1);
    const [pages, setPages] = useState(0);
    const [messages, setMessages] = useState(null);
    const [view, setView] = useState(MAIL_VIEWS.CURRENT);
    const loading = useRef(false);

    useEffect(() => {
        loadCoaches();
    }, []);

    useEffect(() => {
        document.body.style.backgroundColor = '#fff';
        return () => document.body.style.backgroundColor = null;
    }, []);

    useEffect(() => {
        loadMail();
    }, [page]);

    useEffect(() => {
        setMessages(null);
        if (page === 1) {
            setPage(1);
            loadMail();
        } else {
            setPage(1)
        }
    }, [view]);

    // grab user coaches
    async function loadCoaches() {
        try {
            const res = await fetchUserCoaches();
            setCoaches(res);
        } catch (e) {
            console.log(e);
        }
    }

    // load member message threads
    async function loadMail() {
        if (page > pages && page > 1){
            return loading.current = false;
        }
        try {
            const archived = view === MAIL_VIEWS.ARCHIVED;
            const res = await fetchMessages(page, {archived});
            if (messages && page > 1) {
                setMessages([...messages, ...res.threads]);
            } else {
                setMessages(res.threads);
            }
            setPages(res.pages);
            loading.current = false;
            console.log(res.threads);
        } catch(e) {
            console.log(e);
        }
    }

    function next() {
        if (loading.current) return;
        loading.current = true;
        setPage(prevState => prevState +1);
    }

    return (
        <>
            <div className={`client-container`}>
                <div >
                    <ClientHeader backUrl={`/member/clientDash/${user.username}`}/>
                </div>
                <div className="general-container container">
                    <h3>Ready to connect 1 on 1 with a registered dietitian?</h3>
                    <p>Dietitian Live provides personalized guidance to help you reach your health goals</p>
                    <ol className={styles.list}>
                        <li>Click the button below</li>
                        <li>Book your first session at no cost by filling out a brief form and choose your appointment date.</li>
                        <li>You'll get a text or email to confirm your appointment and complete your insurance details.</li>
                        <li>Meet with your remote dietitian, discuss your goals as well as your coverage details for ongoing sessions.</li>
                    </ol>
                    <div className={styles.button} onClick={() => window.open('https://dietitianlive.com/treo-wellness', '_blank').focus()}>
                        <img src={'https://treo.s3.us-east-2.amazonaws.com/assets/image.png'}
                             style={{width: 124, height: 30}} alt=''/>

                    </div>
                </div>
            </div>
        </>

    )
}

function mapStateToProps({user}) {
    return {
        user
    }
}

export default connect(mapStateToProps)(MemberMail);